import { ModalidadeCursoCertificacao } from 'src/tipos'

export const OPCOES_MODALIDADE = [
  {
    id: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Presencial],
    texto: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Presencial]
  },
  {
    id: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Online],
    texto: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Online]
  },
  // {
  //   id: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Hibrido],
  //   texto: ModalidadeCursoCertificacao[ModalidadeCursoCertificacao.Hibrido]
  // },
  {
    id: 'Todas',
    texto: 'Todas'
  }
]
